import { FC } from 'react';

type Props = {
	className?: string;
};

const OwnersIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M10.8327 5.83333C10.8327 7.67428 9.34027 9.16667 7.49935 9.16667C5.6584 9.16667 4.16602 7.67428 4.16602 5.83333C4.16602 3.99238 5.6584 2.5 7.49935 2.5C9.34027 2.5 10.8327 3.99238 10.8327 5.83333Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M12.5 9.16667C14.3409 9.16667 15.8333 7.67428 15.8333 5.83333C15.8333 3.99238 14.3409 2.5 12.5 2.5'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.16602 11.6667H5.83268C3.5315 11.6667 1.66602 13.5322 1.66602 15.8334C1.66602 16.7539 2.41221 17.5001 3.33268 17.5001H11.666C12.5865 17.5001 13.3327 16.7539 13.3327 15.8334C13.3327 13.5322 11.4672 11.6667 9.16602 11.6667Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
			<path
				d='M14.166 11.6667C16.4672 11.6667 18.3327 13.5322 18.3327 15.8334C18.3327 16.7539 17.5865 17.5001 16.666 17.5001H15.416'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default OwnersIcon;
